import { useEffect, useMemo, useRef } from 'react';

import useRenderingEnv from '../../hooks/useRenderingEnv';
import { getMountNode, getPortalNode } from '../helpers';
import { setRef } from '../../utils';

const usePortal = ({ mountNode, nodeType, portalRef, ...rest }) => {
  const env = useRenderingEnv();
  const { isBrowser, isServer } = env;

  const portalElement = useRef(getPortalNode(nodeType, env, portalRef));
  const targetElement = useRef(null);

  const elementToMountTo = useMemo(() => {
    if (isServer) return null;
    return getMountNode(mountNode, env);
  }, [isServer, mountNode]);

  useEffect(() => {
    elementToMountTo.appendChild(portalElement.current);
    return () => {
      elementToMountTo.removeChild(portalElement.current);
      portalElement.current = null;
      targetElement.current = null;
      if (portalRef) {
        setRef(null);
      }
    };
  }, []);

  useEffect(() => {
    if (isBrowser && !portalElement.current) {
      portalElement.current = getPortalNode(nodeType, env, portalRef);
    }
  }, [isBrowser, nodeType, portalRef]);

  return elementToMountTo;
};

export default usePortal;
